import { render, staticRenderFns } from "./PayrollReview.vue?vue&type=template&id=39a41c7c&scoped=true&"
import script from "./PayrollReview.vue?vue&type=script&lang=js&"
export * from "./PayrollReview.vue?vue&type=script&lang=js&"
import style0 from "./PayrollReview.vue?vue&type=style&index=0&id=39a41c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a41c7c",
  null
  
)

export default component.exports